```vue
<template>
  <transition name="modal">
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-70 animate-modalFade">
      <div class="bg-gray-800 rounded-lg w-full max-w-3xl p-6 shadow-lg border border-gray-600 animate-scaleIn">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold text-indigo-300">แก้ไขสูตรคราฟ: {{ editCraftRecipe.name || 'ไม่ระบุ' }}</h3>
          <button @click="closeModal" class="text-gray-300 hover:text-indigo-300 group">
            <i class="fas fa-times text-base group-hover:scale-110 transition-transform duration-200"></i>
          </button>
        </div>
        <div class="space-y-4">
          <div v-if="error" class="text-red-300 text-sm text-center">
            {{ error }}
          </div>
          <div class="grid grid-cols-3 gap-4">
            <div>
              <label for="editCraftName" class="block text-indigo-200 mb-1 text-sm">ชื่อไอเทม</label>
              <input
                id="editCraftName"
                v-model="editCraftRecipe.name"
                type="text"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                disabled
              />
            </div>
            <div>
              <label for="editCraftType" class="block text-indigo-200 mb-1 text-sm">ประเภท</label>
              <select
                id="editCraftType"
                v-model="editCraftRecipe.type"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
              >
                <option value="">เลือกประเภท</option>
                <option v-for="type in craftTypes" :key="type.value" :value="type.value">{{ type.label }}</option>
              </select>
            </div>
            <div>
              <label for="editCraftLevel" class="block text-indigo-200 mb-1 text-sm">ระดับ</label>
              <input
                id="editCraftLevel"
                v-model.number="editCraftRecipe.level"
                type="number"
                min="1"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น 1"
              />
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label for="editCraftRequiredInt" class="block text-indigo-200 mb-1 text-sm">ความฉลาดที่ต้องใช้</label>
              <input
                id="editCraftRequiredInt"
                v-model.number="editCraftRecipe.requiredInt"
                type="number"
                min="0"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น 80"
              />
            </div>
            <div>
              <label for="editCraftRequiredSkill" class="block text-indigo-200 mb-1 text-sm">ทักษะที่ต้องใช้ (ถ้ามี)</label>
              <input
                id="editCraftRequiredSkill"
                v-model="editCraftRecipe.requiredSkill"
                type="text"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น หนังสือวิธีการทำหน้ากาก"
              />
            </div>
          </div>
          <div class="grid grid-cols-3 gap-4">
            <div>
              <label for="editCraftMaxCrafts" class="block text-indigo-200 mb-1 text-sm">จำนวนครั้งที่คราฟได้ (ว่างไว้ถ้าไม่จำกัด)</label>
              <input
                id="editCraftMaxCrafts"
                v-model.number="editCraftRecipe.maxCrafts"
                type="number"
                min="1"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น 5"
              />
            </div>
            <div>
              <label for="editCraftTransferChance" class="block text-indigo-200 mb-1 text-sm">โอกาสโอนได้ (%)</label>
              <input
                id="editCraftTransferChance"
                v-model.number="editCraftRecipe.transferChance"
                type="number"
                min="0"
                max="100"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น 0"
              />
            </div>
            <div>
              <label for="editCraftSuccessChance" class="block text-indigo-200 mb-1 text-sm">โอกาสสำเร็จ (%)</label>
              <input
                id="editCraftSuccessChance"
                v-model.number="editCraftRecipe.successChance"
                type="number"
                min="0"
                max="100"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="เช่น 80"
              />
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label for="editCraftExpirationDate" class="block text-indigo-200 mb-1 text-sm">วันและเวลาหมดอายุ (ว่างไว้ถ้าไม่มี)</label>
              <input
                id="editCraftExpirationDate"
                v-model="editCraftRecipe.expirationDate"
                type="datetime-local"
                class="w-full bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
              />
            </div>
            <div class="flex items-center">
              <input
                id="editCraftIsRecommended"
                v-model="editCraftRecipe.isRecommended"
                type="checkbox"
                class="bg-gray-700 rounded text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-600 border border-gray-600"
              />
              <label for="editCraftIsRecommended" class="ml-2 text-indigo-200 text-sm">แนะนำสูตรนี้</label>
            </div>
          </div>
          <div>
            <label class="block text-indigo-200 mb-1 text-sm">วัตถุดิบ</label>
            <div v-for="(material, index) in editCraftRecipe.materials" :key="index" class="flex items-center gap-2 mb-2">
              <input
                v-model="material.itemName"
                type="text"
                class="flex-1 bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="ชื่อวัตถุดิบ"
              />
              <input
                v-model.number="material.quantity"
                type="number"
                min="1"
                class="w-20 bg-gray-700 text-indigo-200 border border-gray-600 rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-600"
                placeholder="จำนวน"
              />
              <button
                v-if="editCraftRecipe.materials.length > 1"
                @click="removeMaterial(index)"
                class="bg-red-600 hover:bg-red-500 text-white rounded-md p-2 text-sm transition-all duration-200 group"
              >
                <i class="fas fa-minus text-sm group-hover:scale-110"></i>
              </button>
            </div>
            <button
              @click="addMaterial"
              class="bg-indigo-600 hover:bg-indigo-500 text-white rounded-md p-2 text-sm font-semibold transition-all duration-200 group"
            >
              <i class="fas fa-plus mr-1 text-sm group-hover:scale-110"></i> เพิ่มวัตถุดิบ
            </button>
          </div>
          <div class="flex justify-end gap-4 mt-4">
            <button
              @click="updateRecipe"
              :class="[
                'flex items-center bg-indigo-600 text-white px-4 py-2 rounded-md font-semibold transition-all duration-200 text-sm group',
                { 'opacity-50 cursor-not-allowed': isUpdating },
              ]"
              :disabled="isUpdating"
            >
              <span v-if="!isUpdating">
                <i class="fas fa-save mr-1 text-sm group-hover:scale-110"></i> บันทึก
              </span>
              <i v-else class="fas fa-spinner animate-spin-pulse text-sm"></i>
            </button>
            <button
              @click="closeModal"
              class="flex items-center bg-gray-600 hover:bg-gray-500 text-white px-4 py-2 rounded-md font-semibold transition-all duration-200 text-sm group"
            >
              <i class="fas fa-times mr-1 text-sm group-hover:scale-110"></i> ยกเลิก
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { ref } from 'vue';
import dayjs from 'dayjs';

export default {
  name: 'EditCraftModal',
  props: {
    recipe: {
      type: Object,
      required: true,
    },
    craftTypes: {
      type: Array,
      required: true,
    },
    availableSkills: {
      type: Array,
      required: true,
    },
    isUpdating: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update', 'close'],
  setup(props, { emit }) {
    const error = ref('');

    // Initialize editCraftRecipe with formatted expiration date
    const editCraftRecipe = ref({
      id: props.recipe.id,
      name: props.recipe.name,
      type: props.recipe.type || '',
      level: props.recipe.level || 1,
      materials: props.recipe.materials.map((m) => ({ ...m })),
      requiredInt: props.recipe.requiredInt || 0,
      requiredSkill: props.recipe.requiredSkill || '',
      maxCrafts: props.recipe.maxCrafts || null,
      isRecommended: props.recipe.isRecommended || false,
      expirationDate: props.recipe.expirationDate
        ? dayjs(props.recipe.expirationDate).format('YYYY-MM-DDTHH:mm')
        : '',
      transferChance: props.recipe.transferChance || 0,
      successChance: props.recipe.successChance || 100,
    });

    const addMaterial = () => {
      editCraftRecipe.value.materials.push({ itemName: '', quantity: 1 });
    };

    const removeMaterial = (index) => {
      if (editCraftRecipe.value.materials.length > 1) {
        editCraftRecipe.value.materials.splice(index, 1);
      }
    };

    const updateRecipe = () => {
      error.value = '';

      // Validate inputs
      if (
        !editCraftRecipe.value.type ||
        editCraftRecipe.value.level < 1 ||
        editCraftRecipe.value.materials.some((m) => !m.itemName.trim() || m.quantity <= 0) ||
        editCraftRecipe.value.requiredInt < 0 ||
        editCraftRecipe.value.transferChance < 0 ||
        editCraftRecipe.value.transferChance > 100 ||
        editCraftRecipe.value.successChance < 0 ||
        editCraftRecipe.value.successChance > 100
      ) {
        error.value = 'กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง';
        return;
      }

      // Prepare data for update
      const updatedRecipe = {
        ...editCraftRecipe.value,
        expirationDate: editCraftRecipe.value.expirationDate
          ? new Date(editCraftRecipe.value.expirationDate).toISOString()
          : null,
      };

      emit('update', updatedRecipe);
    };

    const closeModal = () => {
      error.value = '';
      emit('close');
    };

    return {
      error,
      editCraftRecipe,
      addMaterial,
      removeMaterial,
      updateRecipe,
      closeModal,
    };
  },
};
</script>

<style scoped>
.animate-modalFade {
  animation: modalFade 0.3s ease-out;
}
@keyframes modalFade {
  from { opacity: 0; }
  to { opacity: 1; }
}
.animate-scaleIn {
  animation: scaleIn 0.3s ease-out;
}
@keyframes scaleIn {
  from { transform: scale(0.95); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
</style>
```